import IViewAdminSolarPlantAlertsRequestDTO from "../../../shared/oversight-core/dtos/request-dtos/view-admin-solar-plant-alerts-request-dto";
import IViewCustomerSolarPlantGraphRequestDTO from "../../../shared/oversight-core/dtos/request-dtos/view-customer-solar-plant-graph-request-dto";
import IViewUserSolarPlantDailyPowerRequestDTO from "../../../shared/oversight-core/dtos/request-dtos/view-user-solar-plant-daily-power-request-dto";
import IViewUserSolarPlantEnergyRequestDTO from "../../../shared/oversight-core/dtos/request-dtos/view-user-solar-plant-energy-request-dto";
import IViewAdminSolarPlantAlertsResponseDTO from "../../../shared/oversight-core/dtos/response-dtos/view-admin-solar-plant-alerts-response-dto";
import IViewAllGenerationServiceProvidersResponseDTO from "../../../shared/oversight-core/dtos/response-dtos/view-all-generation-service-providers-response-dto";
import IViewCustomerSolarPlantGraphResponseDTO from "../../../shared/oversight-core/dtos/response-dtos/view-customer-solar-plant-graph-response-dto";
import IViewUserSolarPlantDetailsResponseDTO from "../../../shared/oversight-core/dtos/response-dtos/view-user-solar-plant-details-response-dto";
import IViewUserSolarPlantEnergyResponseDTO from "../../../shared/oversight-core/dtos/response-dtos/view-user-solar-plant-energy-response-dto";
import IViewUserSolarPlantPowerResponseDTO from "../../../shared/oversight-core/dtos/response-dtos/view-user-solar-plant-power-response-dto";
import IViewUserSolarPlantInvertersResponseDTO from "../../../shared/oversight-core/dtos/response-dtos/view-user-solar-plantInverters-response-dto";
import { transformErrorResponse } from "../../../shared/oversight-core/utils/transformErrorResponse";
import { rootApi } from "../apiManager";

export const generationAPI = rootApi.injectEndpoints({
  endpoints: (builder) => ({
    viewCustomerPlantDetails: builder.query<
      IViewUserSolarPlantDetailsResponseDTO,
      {
        plantId: string;
      }
    >({
      transformErrorResponse,
      query({ plantId }) {
        return {
          url: `admin/generation-service-provider/${plantId}/view`,
          method: "GET",
        };
      },
    }),
    viewUserPlantDailyPower: builder.query<
      IViewUserSolarPlantPowerResponseDTO,
      IViewUserSolarPlantDailyPowerRequestDTO
    >({
      transformErrorResponse,
      query(data: IViewUserSolarPlantDailyPowerRequestDTO) {
        return {
          url: `admin/generation-service-provider/${data.plantId}/power/view`,
          method: "POST",
          body: {
            year: data.year,
            month: data.month,
            day: data.day,
          },
        };
      },
    }),
    viewUserPlantGeneration: builder.query<
      IViewUserSolarPlantEnergyResponseDTO,
      IViewUserSolarPlantEnergyRequestDTO
    >({
      transformErrorResponse,
      query(data: IViewUserSolarPlantEnergyRequestDTO) {
        return {
          url: `admin/generation-service-provider/${data.plantId}/energy-generation/view`,
          method: "POST",
          body: {
            year: data.year,
            month: data.month,
            day: data.day,
            viewType: data.viewType,
          },
        };
      },
    }),
    viewUserPlantInverters: builder.query<
      IViewUserSolarPlantInvertersResponseDTO,
      {
        plantId: string;
        pageNumber?: number;
        pageSize?: number;
        sortBy?: string;
        ascending?: boolean;
      }
    >({
      transformErrorResponse,
      query({ plantId, pageNumber, pageSize, sortBy, ascending }) {
        return {
          url: `admin/generation-service-provider/${plantId}/inverters/view`,
          method: "GET",
          params: {
            pageNumber: pageNumber,
            pageSize: pageSize,
            sortBy: sortBy,
            ascending: ascending,
          },
        };
      },
    }),
    viewGenerationServiceProviders: builder.query<
      IViewAllGenerationServiceProvidersResponseDTO,
      void
    >({
      transformErrorResponse,
      query() {
        return {
          url: `energy-generation/generation-service-provider/list`,
          method: "GET",
        };
      },
    }),
    viewSolarPlantAlertsAdmin: builder.query<
      IViewAdminSolarPlantAlertsResponseDTO,
      IViewAdminSolarPlantAlertsRequestDTO
    >({
      transformErrorResponse,
      query({ plantId, pageNumber, pageSize, sortBy, ascending, start, end }) {
        return {
          url: `admin/generation-service-provider/${plantId}/alerts`,
          method: "GET",
          params: {
            pageNumber,
            pageSize,
            sortBy,
            ascending,
            start,
            end,
          },
        };
      },
    }),
    viewCustomerPlantGraphsAdmin: builder.query<
      IViewCustomerSolarPlantGraphResponseDTO,
      IViewCustomerSolarPlantGraphRequestDTO
    >({
      transformErrorResponse,
      query({ plantId, startDate, endDate, viewType, graphType }) {
        return {
          url: `admin/generation-service-provider/${plantId}/graph/view`,
          method: "GET",
          params: {
            startDate,
            endDate,
            viewType,
            graphType,
          },
        };
      },
    }),
    changeSolarPlantStatus: builder.mutation<void, { plantId: string }>({
      transformErrorResponse,
      query({ plantId }) {
        return {
          url: `admin/generation-service-provider/solar-plant/${plantId}/change-status`,
          method: "PUT",
        };
      },
    }),
  }),
  overrideExisting: false,
});

export const {
  useLazyViewCustomerPlantDetailsQuery,
  useLazyViewUserPlantDailyPowerQuery,
  useLazyViewUserPlantGenerationQuery,
  useLazyViewUserPlantInvertersQuery,
  useLazyViewGenerationServiceProvidersQuery,
  useLazyViewSolarPlantAlertsAdminQuery,
  useLazyViewCustomerPlantGraphsAdminQuery,
  useChangeSolarPlantStatusMutation,
} = generationAPI;
